<template>
	<PageRequestCreate
		v-if="mode === 'edit'"
		v-bind="$attrs"
		:resource="resource"
		v-on="$listeners"
	/>
	<PageRequestReview
		v-else-if="mode === 'view'"
		v-bind="$attrs"
		:resource="resource"
		v-on="$listeners"
	/>
</template>

<script>
import { mapActions, mapState } from 'vuex';

const PageRequestCreate = () => import('./create/index');
const PageRequestReview = () => import('./review/index');


export default {
	name: 'PageRequestDetails',

	components: {
		PageRequestCreate,
		PageRequestReview,
	},

	props: {
		resource: {
			type: String,
			default: 'request',
		},
	},

	computed: {
		...mapState('app', {
			appSide: 'side',
		}),

		mode() {
			if (this.appSide === 'dsp' && this.resource === 'request') {
				return 'edit';
			}

			return 'view';
		},
	},
};
</script>
